import { useState, useCallback } from 'react'
import Box from '@mui/material/Box'
import ShareCodeInput from './ShareCodeInput'
import api from 'services/api'
import LoadingButton from '@mui/lab/LoadingButton'
import useToast from 'hooks/useToast'
import Heading from './Heading'

const DeleteCoverVideo = () => {
  const toast = useToast()
  const [shareLink, setShareLink] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const deleteVideo = useCallback(async () => {
    if (!shareLink) return

    const shareCode = shareLink.split('/').slice(-1)[0]
    try {
      setIsLoading(true)
      await api.reclips.deleteCoverVideoByShareCode(shareCode)
      setShareLink('')
      toast({ message: 'video deleted' })
    } catch (e) {
      toast({ message: e.message, severity: 'error' })
    } finally {
      setIsLoading(false)
    }
  }, [shareLink, toast])

  return (
    <Box>
      <Heading text="1. Enter share link" />
      <ShareCodeInput shareLink={shareLink} onChange={setShareLink} />
      <Heading text="2. Delete the video" />
      <LoadingButton
        variant="contained"
        disabled={!shareLink}
        onClick={deleteVideo}
        loading={isLoading}
      >
        Delete Vid
      </LoadingButton>
    </Box>
  )
}

export default DeleteCoverVideo
